import React, { useEffect, useRef, useState } from "react";

import Navigation from "@components/common/Navigation/Navigation";
import MasterNavigation from "@components/common/Navigation/MasterNavigation";
import PromoSlider from "@components/common/widgets/PromoSlider";
import FloatingPromotionView from "@components/home/FloatingPromotionView";
import PhoneBundles from "@components/common/widgets/PhoneBundles";
import Footer from "@components/common/footer/Footer";
import SlidingAnnouncements from "@components/common/SlidingAnnouncements";
import PopUpAlertMessageBox from "@components/common/PopUpAlertMessageBox";
import ServicesSection from "@components/home/servicesSection/ServicesSection";
import SpecialSelectSection from "@components/home/specialSelectSection/SpecialSelectSection";
import VasSection from "@components/home/vasSection/VasSection";
import FeaturedPlansSection from "@components/home/featurePlansSection/FeaturedPlansSection";
import PopUpBanner from "@components/common/PopUpBanner";
import YouTubePopup from "@components/common/YouTubePopup";
import SmartAppBanner from "@components/common/widgets/SmartAppBanner";
import FloatingActionButton from "@components/common/FloatingActionButton";

import useScript from "@hooks/useScript";

export default function HomeApp() {
  useScript("assets/js/adobe-analytics.js");

  const [isFloatingPromotionViewVisible, setIsFloatingPromotionViewVisible] = useState(false);
  
  return (
    <div className="row-height-100 d-relative">
      <SmartAppBanner />
      {/* <AlertBox /> */}
      <SlidingAnnouncements />
      <PopUpAlertMessageBox />
      <PopUpBanner />
      <Navigation />

      {/* <MasterNavigation /> */}
      <main>
        <PromoSlider urlAPI="promoslider.home" />
        <ServicesSection />
        <FeaturedPlansSection />

        <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
          <PhoneBundles theme="purple" apiCallPath={"phone-bundles"} />
        </div>

        <VasSection />
        <SpecialSelectSection />
      </main>
      <Footer />

      <FloatingActionButton isFloatingPromotionViewVisible={isFloatingPromotionViewVisible}/>
      <FloatingPromotionView isVisible={isFloatingPromotionViewVisible} setIsVisible={setIsFloatingPromotionViewVisible}/>
      <YouTubePopup />
    </div>
  );
}
